<div class="h-full w-full desktop:px-[76px]">
    <slot />
</div>
